export default __webpack_public_path__ + "static/banner_wantedly-62a88dcf15d8cce8a4780b37dd3ab282.png";